import React from "react";

const NewLogoWhite = ({
  width = 33,
  height = 33,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 27.8751V24.2193C22.7161 24.8739 21.2875 25.2203 19.8288 25.2182C14.7532 25.2182 10.6338 21.0988 10.6338 16.0232C10.6338 11.8448 13.4254 8.31453 17.244 7.19689L14.7504 5.25751C14.5359 5.09061 14.2718 5 14 5C13.7282 5 13.4641 5.09061 13.2496 5.25751L3.47178 12.8622C3.32477 12.9765 3.20584 13.123 3.12408 13.2903C3.04231 13.4577 2.99987 13.6415 3 13.8277V26.6733C3 26.9974 3.12877 27.3083 3.35798 27.5375C3.58719 27.7667 3.89807 27.8955 4.22222 27.8955H23.7778C23.8528 27.8955 23.9272 27.8886 24 27.8751Z"
        fill="#FAFAFA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.3593 23.707L28.3871 23.7342L29.7853 22.3041L26.1756 18.775C26.5866 17.8792 26.8028 16.8994 26.8013 15.9007C26.8013 12.0915 23.7098 9 19.9007 9C16.0915 9 13 12.0915 13 15.9007C13 19.7098 16.0915 22.8013 19.9007 22.8013C21.4664 22.8036 22.9858 22.2709 24.2075 21.2916L27.4906 24.5756L28.3593 23.707ZM23.5757 16.0781C23.5757 18.0111 22.0087 19.5781 20.0757 19.5781C18.1427 19.5781 16.5757 18.0111 16.5757 16.0781C16.5757 14.1451 18.1427 12.5781 20.0757 12.5781C22.0087 12.5781 23.5757 14.1451 23.5757 16.0781Z"
        fill="#FAFAFA"
      />
    </svg>
  );
};

export default NewLogoWhite;
